import React, { type PropsWithChildren } from 'react';
import { ErrorBoundary } from '@atlassian/jira-error-boundary';
import SettingsContainerContent from './main';

type ContainerProps = {
	packageId: string;
};

export const SettingsContainer = ({ children, packageId }: PropsWithChildren<ContainerProps>) => (
	<ErrorBoundary id={packageId} packageName={packageId}>
		<SettingsContainerContent>{children}</SettingsContainerContent>
	</ErrorBoundary>
);
